import * as tslib_1 from "tslib";
import { Button } from "@h3/antd-vue";
import { DataSelectTextInputControl } from "@cloudpivot/form/src/common/controls/input-controls/data-select-text-input-control";
import { Component } from "vue-property-decorator";
import Axios from "axios";
let WorkReport = class WorkReport extends DataSelectTextInputControl {
    constructor() {
        super(...arguments);
        this.list = [];
        this.corpId = "";
        this.clientId = "";
        this.appCode = "work_report";
    }
    showModal() {
        let userAgent = window.navigator.userAgent.toLowerCase();
        const isAndroid = /android/.test(userAgent);
        const isFlat = /ipad|playbook/.test(userAgent) || (isAndroid && !/mobile/.test(userAgent));
        if (isFlat) {
            // ipad
            const options = {
                corpId: this.corpId,
                ids: this.list.map((item) => item.id),
                type: "h5"
            };
            window.GZHB_SDK.getWorkReportH5(options).then((res) => {
                this.list = res.data.map((item) => {
                    return {
                        id: item.id,
                        main: item.main,
                    };
                });
                this.setValue(JSON.stringify(this.list));
            });
        }
        else {
            const options = {
                corpId: this.corpId,
                ids: this.list.map((item) => item.id),
            };
            window.GZHB_SDK.getWorkReport(options).then((res) => {
                console.log("GZHB_SDK.getWorkReport(options).then((res)");
                console.log(res);
                this.list = res.data.map((item) => {
                    return {
                        id: item.id,
                        main: item.main,
                    };
                });
                this.setValue(JSON.stringify(this.list));
            });
        }
    }
    getSign(apiPath) {
        const token = localStorage.getItem("token");
        let url = `${location.origin}/api/ext/cwork/open/sign/${this.appCode}`;
        const cfg = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        let params = { url: apiPath };
        return Axios.post(url, params, cfg).then((d) => {
            return {
                data: d.data || {},
                success: d.errcode === 0,
            };
        });
    }
    bindUser(openId, dingUserId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const token = localStorage.getItem("token");
            let apiPath = "/api/ext/cwork/open/saveUserOpenId";
            let url = `${location.origin}${apiPath}?openId=${openId}&dingUserId=${dingUserId || ''}`;
            const cfg = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            };
            let params = { url: apiPath };
            return Axios.post(url, params, cfg).then((d) => {
                return {
                    data: d.data || {},
                    success: d.errcode === 0,
                };
            });
        });
    }
    loadJS(src) {
        return new Promise((resolve, reject) => {
            let script = document.createElement("script");
            script.src = src;
            script.onload = resolve;
            script.onerror = reject;
            script.setAttribute("referrerpolicy", "no-referrer");
            document.body.append(script);
        });
    }
    loadCSS(href) {
        return new Promise((resolve, reject) => {
            let link = document.createElement("link");
            link.href = href;
            link.rel = "stylesheet";
            link.onload = () => {
                resolve(link);
            };
            link.onerror = () => {
                reject();
                link.remove();
            };
            link.setAttribute("referrerpolicy", "no-referrer");
            document.body.append(link);
        });
    }
    created() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const host = (location.host || location.origin).toLowerCase();
            let isDev = /\-dev/.test(host);
            let isTest = /test\-/.test(host);
            let isPre = /\-pre/.test(host);
            const now = new Date();
            const t = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
            // 生产环境sdk https://xg.mediportal.com.cn/gong-zuo-hui-bao-js-sdk1/web/build/GZHB_SDK.js
            // 测试环境sdk https://test.xgjktech.com.cn/gong-zuo-hui-bao-js-sdk1/web/build/GZHB_SDK.js
            let sdkDomain = 'https://xg.mediportal.com.cn';
            // 测试、dev等环境，都加载test环境的sdk
            if (isDev || isTest || isPre)
                sdkDomain = 'https://test.xgjktech.com.cn';
            yield Promise.all([
                this.loadJS(`${sdkDomain}/gong-zuo-hui-bao-js-sdk1/web/build/GZHB_SDK.js?t=${t.getTime()}`),
                this.loadCSS(`${sdkDomain}/gong-zuo-hui-bao-js-sdk1/web/build/css/index.css?t=${t.getTime()}`)
            ]);
            let corpId = localStorage.getItem("corpId");
            if (!corpId) {
                // 兼容 ipad
                const user = sessionStorage.user;
                if (user) {
                    try {
                        corpId = JSON.parse(user).corpId;
                    }
                    catch (e) { }
                }
            }
            this.corpId = corpId || "";
            if (window.GZHB_SDK) {
                // 工作汇报sdk，默认在生产环境，检测域名在其他环境，就切换一下
                if (isTest) {
                    // 测试环境
                    window.GZHB_SDK.setEnvironment({
                        api: "https://cwork-api-test.xgjktech.com.cn",
                        origin: "https://cwork-web-test.xgjktech.com.cn",
                    });
                }
                else if (isPre) {
                    // pre 环境
                    window.GZHB_SDK.setEnvironment({
                        api: "https://cwork-api-pre.xgjktech.com.cn",
                        origin: "https://cwork-web-pre.xgjktech.com.cn",
                    });
                }
                else if (isDev) {
                    // dev环境
                    window.GZHB_SDK.setEnvironment({
                        api: "https://cwork-api-dev.xgjktech.com.cn",
                        origin: "https://cwork-web-dev.xgjktech.com.cn",
                    });
                }
                window.GZHB_SDK.setSignFn(this.getSign);
                window.GZHB_SDK.setBindUserFn(this.bindUser);
            }
        });
    }
    mounted() {
        // 预览/编辑
        if (this.readonly && this.val) {
            const list = JSON.parse(this.val);
            if (Array.isArray(list)) {
                this.list = list;
            }
            else {
                this.list = [];
            }
        }
    }
    getUrl(data) {
        window.GZHB_SDK.showWorkReportDetails(data.id, this.corpId);
    }
    handleValueChange(value) {
        if (value) {
            let list = JSON.parse(value);
            if (Array.isArray(list)) {
                this.list = list;
            }
            else {
                this.list = [];
            }
        }
        else {
            this.list = [];
        }
    }
    delList(index) {
        this.list.splice(index, 1);
        if (this.list.length > 0) {
            this.setValue(JSON.stringify(this.list));
        }
        else {
            this.setValue('');
        }
    }
};
WorkReport = tslib_1.__decorate([
    Component({
        name: "WorkReport",
        components: {
            AButton: Button,
        },
    })
], WorkReport);
export default WorkReport;
